import React from 'react';

export default class Page7 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToCommunicateEffectively');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                                <section>
                                    <div className="">
                                        <div className="ilead-rgt people">
                                            <div className="innerpadding">
                                                <div className="ilead-contentarea">

                                                    <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                        <span className="heading">Further Information</span>
                                                    </div>

                                                    <div className="paraspace"><p>If you found this tool useful then you
                                                        are likely to find the following tools both insightful and
                                                        relevant:</p></div>
                                                    <div className="keyquestionpad">
                                                        <ul className="greenbullet-list">
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToBeAssertive')}>How
                                                                to be assertive</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToInfluenceOthers')}>How
                                                                to influence others</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToDevelopRapport')}>How
                                                                to develop rapport</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToActivelyListen')}>How
                                                                to actively listen</div></li>
                                                            <li><div className="link_color button-link-redirect people"
                                                                   onClick={this._savePageStatus('HowToCommunicateYourVision')}>How
                                                                to communicate your vision.</div></li>

                                                        </ul>
                                                    </div>
                                                    <div className="circle_title referencepad"><img
                                                        src={require('@images/browndot.jpg')}
                                                        alt=""/>REFERENCES</div>

                                                    <ol className="testclass">
                                                        <li><p className="further_info_content">Nabi, R. L.,
                                                            Roskos-Ewoldsen, D., &amp; Carpentier, F. D. (2008).
                                                            Subjective knowledge and fear appeal
                                                            effectiveness: Implications for message design. <span
                                                                className="subtiltereg"> Health communication,</span> 23(2),
                                                            191-201.</p></li>
                                                        <li><p className="further_info_content">Lewis, I., Watson,
                                                            B., &amp; Tay, R. (2007). Examining the effectiveness of
                                                            physical threats in road safety
                                                            advertising: The role of the third-person effect, gender,
                                                            and age. <span className="subtiltereg"> Transportation Research Part F: Traffic Psychology and Behaviour,</span> 10(1),
                                                            48-60.</p></li>
                                                        <li><p className="further_info_content">Inamori,
                                                            T., &amp; Analoui, F. (2010). Beyond Pygmalion effect: the
                                                            role of managerial perception.<span className="subtiltereg"> Journal of
Management Development,</span> 29(4), 306-321.</p></li>
                                                        <li><p className="further_info_content">Van Cappellen, P.,
                                                            Corneille, O., Cols, S., &amp; Saroglou, V. (2011). Beyond
                                                            mere compliance to authoritative
                                                            figures: Religious priming increases conformity to
                                                            informational influence among submissive people.<span
                                                                className="subtiltereg">
The International Journal for the Psychology of Religion,</span> 21(2), 97-105.</p></li>
                                                        <li><p className="further_info_content">Argyle, M., Alkema,
                                                            F. &amp; Gilmour, R. (1971). The communication of friendly
                                                            and hostile attitudes by verbal
                                                            and non-verbal signals.<span className="subtiltereg">   European Journal of Social Psychology,</span> 1,
                                                            385-402 in Arnold, J., Cooper,
                                                            C. &amp; Roberston, I. (1998). Work Psychology. Prentice
                                                            Hall.</p></li>
                                                        <li><p className="further_info_content">Jones, E. et al (1968).
                                                            Pattern of performance and ability attribution: An
                                                            unexpected primacy effect.<span className="subtiltereg">  Journal
of Personality and Social Psychology,</span> l0, 3l7-340.</p></li>
                                                    </ol>


                                                    <div className="left-btn"><div
                                                         onClick={this.props.handleChangePage('Page6')}
                                                        className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                                    <div className="right-btn"><div
                                                         onClick={this._savePageStatus('People')}
                                                        className="button-next-previous-done">Done</div></div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                    </div>
                </div>
            </div>
        </div>;
    }
    }